import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import WarmupDashboard from '../components/WarmupDashboard';
import WarmupConfiguration from '../components/WarmupConfiguration';
import TokenManagement from '../components/TokenManagement';
import WarmupHistory from '../components/WarmupHistory';
import WalletPriorityList from '../components/WalletPriorityList';

const WalletWarmup = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Wallet Warmup System</h1>
          <p className="text-gray-600">Автоматический разогрев кошельков через свапы токенов</p>
        </div>
        
        <Tabs defaultValue="dashboard" className="space-y-6">
          <TabsList className="grid w-full grid-cols-5">
            <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
            <TabsTrigger value="wallets">Wallets</TabsTrigger>
            <TabsTrigger value="configuration">Configuration</TabsTrigger>
            <TabsTrigger value="tokens">Tokens</TabsTrigger>
            <TabsTrigger value="history">History</TabsTrigger>
          </TabsList>
          
          <TabsContent value="dashboard" className="space-y-4">
            <WarmupDashboard />
          </TabsContent>
          
          <TabsContent value="wallets" className="space-y-4">
            <WalletPriorityList />
          </TabsContent>
          
          <TabsContent value="configuration" className="space-y-4">
            <WarmupConfiguration />
          </TabsContent>
          
          <TabsContent value="tokens" className="space-y-4">
            <TokenManagement />
          </TabsContent>
          
          <TabsContent value="history" className="space-y-4">
            <WarmupHistory />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default WalletWarmup;

